import { JiraIssueAri } from '@atlassian/ari/jira';

export const transformIssueArisToIds = (issueAris: string[]): number[] =>
	issueAris.map((issueAri) => parseInt(JiraIssueAri.parse(issueAri).issueId, 10));
